export const cmdPlusClicked = (e: any) => e.metaKey || e.ctrlKey;
